export default "/images/vendor/flag-icon-css/flags/4x3/lb.svg?75479923a75562bb3dbec6b5243f1860";